<template>
    <v-expand-transition>
        <div v-if="aspectSuggestedMedias.length > 0"
             class="mt-5">
            <div class="suggestion-container">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px;">Photos présentes sur d'autres aspects</b>
                    </div>
                </div>

                <div class="d-flex flex-wrap mb-3 justify-start">
                    <v-hover v-slot="{ hover }" v-for="(media, index) in aspectSuggestedMedias">
                        <v-img height="180px" max-width="290px"
                               class="m-2 v-media media-suggest"
                               @click="selectMedia(media)"
                               style="border-radius: 8px"
                               :src="media.thumbnail_url !== undefined && media.thumbnail_url !== null ?
                                    media.thumbnail_url : media.origin_url">

                            <v-expand-transition v-if="!readOnly">
                                <div v-if="hover"
                                     class="transition-fast-in-fast-out darken-2 v-card--reveal
                                            display-3 white--text text-center"
                                     style="height: 60px; position: absolute; bottom: 0;
                                               width: 100%; background-color: rgba(0,0,0,0.4);">

                                    <v-btn class="default-button text-none"
                                           @click="addSuggestedMedia(index)"
                                           style="transform: translateY(-50%);
                                                  position: relative;top: 25%">
                                        Ajouter
                                    </v-btn>
                                </div>
                            </v-expand-transition>
                        </v-img>
                    </v-hover>
                </div>
            </div>

            <v-snackbar v-model="displaySnackBar" bottom color="primary" :timeout="8000">
                <span>
                    La photo a été ajoutée à votre réponse.
                    Pour nous permettre de la diffuser, il est impératif d'indiquer son
                    <b style="color:#a4ffa4;">copyright</b>.
                </span>
            </v-snackbar>

            <media-full-screen-modal v-if="selectedMedia !== null && mediaFullScreenDialog"
                                     :media="selectedMedia">
            </media-full-screen-modal>
        </div>
    </v-expand-transition>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"
import MediaFullScreenModal from "../modals/MediaFullScreenModal.vue"

export default {
    name: "AspectMediaSuggestion",
    components: { MediaFullScreenModal },
    data() {
        return {
            displaySnackBar: false,
            selectedMedia: null,
            addMod: false,
        }
    },
    computed: {
        ...mapState("web_form", [
            "provider",
            "aspectSuggestedMedias",
            "mediaFullScreenDialog",
            "readOnly",
        ]),
        ...mapState("webFormStyle", ["primaryColor"]),
    },
    methods: {
        ...mapMutations("web_form", ["addMedia", "setMediaFullScreenDialog", 'setDirtyTabulation',]),
        selectMedia(media) {
            if (!this.addMod) {
                this.selectedMedia = media
                this.setMediaFullScreenDialog(true)
            }
        },
        addSuggestedMedia(index) {
            this.addMod = true

            let media = this.aspectSuggestedMedias[index]

            this.pushMedia(media.origin_url, media.thumbnail_url, media.source, false, media.copyright, media.name)
            this.aspectSuggestedMedias.splice(index, 1)

            this.displaySnackBar = true

            setTimeout(() => {
                this.addMod = false
            }, 1000)
        },
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true, copyright = null, name = null) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: name,
                copyright: copyright,
                temp: temp,
                origin_url: originUrl,
                source: source,
                is_image: true,
                height: null,
                width: null,
            }

            this.addMedia(media)
            this.setDirtyTabulation('MEDIAS')
        },
    },
}
</script>

